<script setup>

import RightLightning from "@/components/NewPC/RightLightning.vue";
import LeftLightning from "@/components/NewPC/LeftLightning.vue";
import {useRouter, useRoute} from "vue-router";
import {onMounted, ref} from "vue";
import {getArticles} from "@/api/common";
const route = useRoute();
const router = useRouter();
const articleDetail = ref(null);
const handleJumpHome = () => {
  router.replace("/");
}
const fetchArticles = () => {
  getArticles({type: route.query.type}).then((res) => {
    console.log(res);
    if (res.status == 200 && res.data && res.data.code == 0) {
      articleDetail.value = res.data.data.find(f => f.id == route.query.id);
      articleDetail.value.content = articleDetail.value.content.replace(/\n/g, '<br />')
    }
  })
}
onMounted(() => {
  fetchArticles();
})

</script>

<template>
<div class="news_detail">
  <img src="@/assets/newPc/page_logo.png" @click="handleJumpHome" alt="" class="page_logo">
  <div class="content">
    <div class="detail_block" v-if="articleDetail">
      <div class="title">{{ articleDetail.title }}</div>
      <div class="other">{{articleDetail.time}}</div>
      <div class="desc" v-html="articleDetail.content">
      </div>
    </div>

  </div>


  <left-lightning class="left_lightning" />
  <right-lightning class="right_lightning" />
</div>
</template>

<style scoped lang="scss">
@import "@/style/fonts.scss";

.news_detail {
  height: 100vh;
  background: transparent url("@/assets/newPc/page_bg.png") no-repeat center center;
  background-size: cover;
  position: relative;
  overflow-y: auto;

  .page_logo {
    width: 7.3046875vw;
    height: 4.0234375vw;
    position: absolute;
    top: 1.8359375vw;
    left: 2.265625vw;
    z-index: 2;
    cursor: pointer;
  }

  .content {
    background: transparent url("@/assets/newPc/news_detail_header_bg.png") no-repeat top center;
    background-size: contain;
    position: relative;
    z-index: 1;
    padding-top: 13.4375vw;
    padding-bottom:  5.6640625vw;
    box-sizing: border-box;
    display: flex;
    justify-content: center;


    .detail_block {
      width: 74.609375vw;
      height: auto;
      background-color: #fff;
      padding: 3.203125vw 5.6640625vw;
      box-sizing: border-box;


      .title {
        color: #464646;
        font-family: 'SourceHanSansCN-Bold';
        font-size: 1.953125vw;
        margin-bottom: 0.9765625vw;
      }

      .other {
        color: #A9A9A9;
        font-size: 0.859375vw;
        font-family: 'SourceHanSansCN-Regular';
        margin-bottom: 2.5390625vw;
      }

      .desc {
        font-family: 'SourceHanSansCN-Normal';
        color: #686868;
        font-size: 1.09375vw;
        overflow-y: auto;
      }
    }
  }


  .left_lightning {
    position: absolute;
    left: 0;
    top: 28.59375vw;
  }

  .right_lightning {
    position: absolute;
    right: 0;
    top: 8.671875vw;
  }
}
</style>